// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .modal{
    z-index:999
} */

.Feed_modalHide__g8BFy {
  display: none !important;
}
.Feed_feed__NFWkr {
  width: 100%;
  position: relative;
  margin-top: 8px;
  height: 153px;
  border-radius: 26px;
  box-shadow: 0px 3px 6px #00000029;
  margin-bottom: 17px;
  overflow: hidden; /* Ensures the image doesn't overflow the container */
}
.Feed_feedOnLoading__QPvVL {
  width: 100%;
  margin-top: 18px;
  height: 153px;
  margin-bottom: 17px;
  text-align: center;

}
.Feed_backgroundImage__SPblc {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  /* object-fit: cover; Ensures the image covers the entire container */
  /* z-index: -1; Places the image behind other content */
  cursor: pointer;
}
.Feed_container__gMeS2 {
  bottom: 0;
  position: absolute;
  display: flex;
  border-radius: 0px 0px 25px 25px;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  background-color: rgb(243 242 240 / 100%);
  padding: 5px 12px;
}

.Feed_navbuttons__z7ALu {
  outline: none !important;
  border: none !important;
  background: #f3f2f0;
  display: inline;
  max-height: 43px;
}

.Feed_moderator__J03se {
  display: flex;
  align-items: center;
  cursor: pointer;
  width: 100%;
}

.Feed_coomFullName__HdSIo {
  font-size: 18px;
  font-weight: 500;
  color: #373334;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.Feed_crown__PWAEU {
  position: absolute;
  top: 20px;
  left: 20px;
  z-index: 1;
}

.Feed_post__tpjac {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  width: 48%;
  border-radius: 20px;
  border: solid 1px gray;
}

.Feed_postinput__HkX17 {
  outline: none;
  padding: 10px 10px 10px 20px;
  border: none;
  width: 100%;
  border-radius: 25px;
  position: relative;
  font-size: 13px;
  color: #707070;
}

input::placeholder {
  text-transform: none !important;
}

.Feed_post__tpjac svg {
  position: absolute;
  left: 20px;
}

.Feed_updates__xk\\+kX {
  width: 48px !important;
}
.Feed_prospectimages__xNGKl {
  margin-right: 13px;
}

.Feed_postbutton__PKKXc {
  outline: none !important;
  border: none;
  border-radius: 25px;
  vertical-align: middle;
  background-color: #707070;
  padding: 6px 16px;
}

.Feed_postDialog__uXQfy {
  outline: none !important;

  background-color: #36b549 !important;
  color: gray !important;
  border-radius: 24px !important;
}

.Feed_UpdateDialog__0RkfR {
  outline: none !important;

  background-color: #ff7e7e !important;
  color: white !important;
  border-radius: 18px !important;
}

.Feed_TagDialog__yQi9- {
  outline: none !important;
  background-color: #ef8a2a !important;
  color: white !important;
  border-radius: 18px !important;
}

.Feed_close__L8aJp {
  border: none;
  outline: none !important;
  background-color: white;
  float: right;
}

.Feed_togglebuttoncover__gcFk0 {
  display: table-cell;
  position: relative;
  width: 200px;
  height: 140px;
  box-sizing: border-box;
}

.Feed_navHome__0LOEG {
  border-radius: 50px;
  width: 15vw;
  height: 60px;
  line-height: 60px;
  background: #fff;
  border: none;
  outline: none;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
}

.Feed_navHome__0LOEG > nav {
  display: flex;
  position: relative;
}

.Feed_navHome__0LOEG > nav > label {
  text-align: center;
  z-index: 1;
  flex: 1 1;
  width: 100%;
  position: relative;
  cursor: pointer;
  margin-bottom: 0;
}

.Feed_navHome__0LOEG > nav > label > a {
  z-index: -1;
  position: relative;
  font-size: 18px;
  font-weight: 500;
  text-decoration: none;
  color: #000;
  transition: color 0.6s ease;
}

.Feed_navHome__0LOEG > nav > .Feed_tab__gu\\+xM {
  position: absolute;
  left: 0;
  height: 100%;
  width: 50%;
  bottom: 0;
  border-radius: 50px;
  background-color: #9c1de7;
  transition: 0.6s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}

.Feed_navHome__0LOEG > nav > input {
  display: none;
}

.Feed_navHome__0LOEG > nav > .Feed_home__tAhO3:checked ~ .Feed_navhome__dWHWP > .Feed_asksaynav__Xe7Ay > label > .Feed_home__tAhO3 > a {
  color: #fff;
}

.Feed_navHome__0LOEG > nav > #Feed_phone__JW9kp:checked ~ .Feed_tab__gu\\+xM {
  left: 50%;
}

.Feed_prospectimagesdiv__IYiDk {
  display: flex;
  /* width: 50%; */
  justify-content: flex-end;
  /* background-color: #50b7f5; */
}
.Feed_invitebutton__Hrq5A {
  display: inline-flex; /* keeps icon + text inline */
  align-items: center; /* vertically centers icon with text */
  white-space: nowrap; /* prevents wrapping */
  border: 1px solid #DEE0E1;
  outline: none !important;
  border-radius: 19px;
  background: #fff;
  padding: 3px 10px 3px 13px;
  color: #373334 !important;
  font-size: 14px;
}
.Feed_invitebutton__Hrq5A svg {
  margin-right: 5px;
  flex-shrink: 0; /* ensures icon never shrinks */
  position: relative;
  /* top: 2px; */
}

.Feed_filterbuttons__LXvlo {
  padding-top: 7px;
  position: absolute;
  box-shadow: 2px 3px 6px darkgrey;
  width: 295px;
  border-radius: 25px 25px 0px 4px;
  right: 0px;
  top: 65px;
  display: inline-flex;
  z-index: -2;
  bottom: 3px;
  justify-content: space-evenly;
}
.Feed_filterbuttons__LXvlo > span {
  padding: 0px 0px 0px 8px;
}
.Feed_filterinput__HYj-n {
  display: flex;
  justify-content: space-between;
  /* padding: 5px 0px 5px 20px; */
  padding: 5px 0px;
  cursor: pointer;
}

.Feed_modalbgcolor__6q-7o {
  background-color: #f3f2f0;
  border-radius: 25px;
  margin-top: 48px;
}

.Feed_modalbody__h-t0x {
  background-color: white;
  margin: 0px 30px;
  border-radius: 25px;
}
.Feed_communitydropdown__BQBeH {
  border-color: black;
  background-color: #fff;
  color: black;
  border-radius: 15px;
}
.Feed_communitydropdown__BQBeH:hover {
  border-color: black;
  background-color: #fff;
  color: black;
}
.Feed_profilenameandimage__rA9aM {
  display: flex;
  margin-bottom: 10px;
}
.Feed_profilename__z6\\+VV {
  margin: 0px 0px 0px 8px;
  font-size: 14px;
  font-weight: bold;
  color: #333;
}
.Feed_profilename__z6\\+VV > p {
  margin: 0 0 0 2px;
  font-size: 14px;
  /* margin-bottom: 0; */
}
.Feed_askSayTextareaContainer__YbYjz {
  display: flex;
  flex-direction: column;
  position: relative;
  margin-bottom: 20px;
}
.Feed_asksaytextarea__28JhJ {
  width: 100%;
  height: 100px;
  resize: none;
  outline: none;
  border-width: 0px;
  border-bottom-width: 1px;
  border-color: gray;
  font-size: 14px;
}
.Feed_redBubble__Zzie0 {
  margin-left: auto;
  margin-top: -23px;
  height: 8px;
}
.Feed_textAreaHorizontalLine__MeAQB {
  color: red;
}
.Feed_locationtagandcharcount__7OweD {
  padding-top: 4px;
  display: flex;
  justify-content: space-between;
  align-content: baseline;
  flex-wrap: wrap;
}
.Feed_locationtagTimeFileandcharcount__9tsId {
  padding-top: 4px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  width: 100%;
}

/* .locationtagicon {
  margin-top: 10px !important;
  position: absolute !important;
  bottom: 14% !important;
} */

.Feed_locationtagicon__N6ybO {
  display: flex;
  justify-content: space-between;
  align-content: flex-start;
  align-items: start;
  flex-wrap: wrap;
}
.Feed_locationtagTimeFileandcharcount__9tsId > div:last-child {
  flex-shrink: 0; /* prevents char count from shrinking */
}
.Feed_locationtagTimeFileIcon__pFWEL {
  display: flex;
  align-items: center;
  flex-wrap: nowrap; /* allows items to wrap if not enough space */
  gap: 8px; /* space between location, calendar, attachment */
  flex: 1 1; /* makes it expand and shrink as needed */
  min-width: 0;
}

.Feed_profileavatar__benSa {
  margin-top: 4px;
  height: 45px !important;
  width: 45px !important;
}

@media all and (min-width: 1440px) {
  .Feed_modalbgcolor__6q-7o {
    width: 600px;
  }
}

@media all and (min-width: 768px) {
  .Feed_asksaybuttons__Nmdh7 {
    position: relative;
    left: 152px;
    margin-bottom: 14px;
  }
}

.Feed_askbutton__CZNDH {
  border: 1px solid !important;
  border-radius: 50px 0px 0px 50px !important;
  width: 21%;
  outline: none !important;
  background-color: white !important;
}
.Feed_saybutton__zd6n3 {
  border: 1px solid !important;
  border-radius: 0px 50px 50px 0px !important;
  width: 21%;
  outline: none !important;
  background-color: white !important;
}

.Feed_modalfooter__6EnFZ {
  justify-content: center;
}
/* .modalfooter>img{
    position: absolute;
    right: 30px;
} */

@media all and (max-width: 991px) {
  .Feed_post__tpjac {
    width: 100%;
  }
}
/* @media all and (max-width: 967px) {
  .container {
    padding-top: 50px;
  }
} */
@media all and (max-width: 320px) {
  .Feed_backgroundimage__g9y2N > img {
    width: 101.5%;

    margin: -94px 0px 0px -1px;
  }
}
@media all and (max-width: 425px) {
  .Feed_backgroundimage__g9y2N > img {
    width: 102.5%;

    margin: -94px 0px 0px -5px;
  }
}

@media all and (max-width: 767px) {
  .Feed_asksaybuttons__Nmdh7 {
    position: relative;
    left: 100px;
    margin-bottom: 14px;
  }
  /* .post svg {
    left: 25px;
  } */
  /* .filterinput {
    padding: 0 10px;
  } */
}

.Feed_postupdatedropdown__5DVeE {
  border-radius: 8px;
  padding: 5px 11px;
  border: 1px solid #999999;
  color: rgba(0, 0, 0, 0.6);
  font-size: 12px;
}

.Feed_postdropdown__h7KHi {
  /* padding: 5px 11px; */
  color: rgba(0, 0, 0, 0.6);
  font-size: 12px;
}

.Feed_arrowStyle__fmwcO {
  height: 10px;
  width: 10px;
}

.Feed_PostSubmit__28KO2 {
  border-radius: 25px;
  min-width: 106px !important;
  cursor: pointer;
  /* background-color: #d8d8d8; */
  box-shadow: 1px 3px 6px;
  border-radius: 25px !important;
}
.Feed_postSelectionWarning__4ojnC {
  z-index: 20;
  position: absolute;
  bottom: 18px;

  box-shadow: 1px 2px 4px;
  border-radius: 55px;
  background: #fff;

  font-size: 12px;
  /* left: 41px; */
  width: 100%;
  /* width: max-content; */
  text-align: center;
  padding: 13px 12px 0px 12px;
}

.Feed_askpost__Ifips {
  background-color: #2168b2 !important;
  color: #ffffff !important;
  text-transform: none !important;
}
.Feed_askButtonDisable__qcbi\\+ {
  background-color: #a2c3e4 !important;
  opacity: 0.4 !important;
  cursor: not-allowed !important;
  color: #ffffff !important;
  text-transform: none !important;
}
.Feed_saypost__S0fmr {
  background-color: #36b549 !important;
  color: #ffffff !important;
  text-transform: none !important;
}
.Feed_sayButtonDisable__OEg62 {
  background-color: #a8d9b0 !important;
  opacity: 0.4 !important;
  cursor: not-allowed !important;
  color: #ffffff !important;
  text-transform: none !important;
}
.Feed_saypost__S0fmr,
.Feed_askpost__Ifips {
  width: 6rem !important;
  /* color: #fff !important; */
  padding-top: 9px;
}
.Feed_initialcount__8pPEi {
  position: relative;
  bottom: 5px;
}

.Feed_additionalcountadd__UHrBE {
  margin-left: 4px;
  color: #707070;
}
.Feed_publicSwitch__BP3Gr {
  outline: none !important;
  border-radius: 50px 0px 0px 50px;
  background-color: white;
  border: 0.5px solid black;
}
.Feed_privateSwitch__6Y1BX {
  outline: none !important;
  border-radius: 0px 50px 50px 0px;
  background-color: white;
  border: 0.5px solid black;
}

.Feed_tagDiv__FToZK > img {
  margin: 0 0 10px 0px;
}
.Feed_tagDiv__FToZK > div {
  list-style: none;
}
.Feed_tagDiv__FToZK > div > button {
  padding: 3px 15px 3px 15px;
  font-size: 14px;
}
.Feed_onPublicSwitchSelect__en6qk {
  color: #50b7f5;
  border: 1px solid #50b7f5;
  background-color: #eff5fb;
}
.Feed_onPrivateSwitchSelect__IbQDE {
  color: #50b7f5;
  border: 1px solid #50b7f5;
  background-color: #eff5fb;
}
.Feed_updateSubmit__uUvB4 {
  border-radius: 25px;
  min-width: 106px !important;
  cursor: pointer;
  /* background-color:#D8D8D8; */
  color: white !important;
  box-shadow: 1px 3px 6px;
  border-radius: 25px !important;
  background-color: #e82727 !important;
  text-transform: none !important;
}
.Feed_updateButtonDisable__hL0gM {
  border-radius: 25px;
  min-width: 106px !important;
  cursor: pointer;
  /* background-color:#D8D8D8; */
  color: white !important;
  box-shadow: 1px 3px 6px;
  border-radius: 25px !important;
  background-color: #e827274f !important;
  text-transform: none !important;
}
.Feed_tagSubmit__HtSmO {
  border-radius: 25px;
  min-width: 106px !important;
  color: white !important;
  cursor: pointer;
  box-shadow: 1px 3px 6px;
  border-radius: 25px !important;
  background-color: #efba29 !important;
  text-transform: none !important;
}
.Feed_tagButtonDisable__xKvz7 {
  border-radius: 25px;
  min-width: 106px !important;
  color: white !important;
  cursor: pointer;
  box-shadow: 1px 3px 6px;
  border-radius: 25px !important;
  background-color: #efba298b !important;
  text-transform: none !important;
}

.Feed_errorMessage__cs3tq {
  color: red;
  font-size: 12px;
}

/*Contact component */
.Feed_address__KK\\+zg {
  display: flex;
  margin-left: 5%;
}
.Feed_address__KK\\+zg p {
  margin-right: 5px;
  margin-top: -2px;
}
.Feed_contactModalbgcolor__IQOx1 {
  background-color: #ffffff;
  border-radius: 25px;
}
.Feed_contactTextarea__ynMnP {
  border: 1px solid #707070;
  margin-left: 4px;
  border-radius: 20px !important;
  resize: none;
  padding-left: 15px;
  padding-top: 5px;
  padding-bottom: 5px;
  outline: none !important;
  width: 98%;
}
.Feed_contactSend__GhKMv {
  border-radius: 25px !important;
  width: 88px;
  background-color: #4795de !important;
  margin: 0 auto;
  color: #ffffff !important;
  border: none;
  height: 33px;
}
.Feed_sendtoContact__Se6vh {
  display: flex;
  justify-content: center;
}

.Feed_addressContact__ucZ2\\+ {
  color: #4795de;
}

.Feed_contactSendButton__PGGrH {
  cursor: none;
  opacity: 0.6;
}
.Feed_overCount__iJ5cG {
  color: red;
}

.Feed_aboutAskInfo__Su-qM {
  position: relative;
  cursor: pointer;
  left: 35%;

  @media screen and (max-width: 576px) {
    left: 28%;
  }
}

.Feed_askAbout__2aGRF {
  display: none;
}
.Feed_askAbout__2aGRF > h6 {
  margin-bottom: 2px;
  font-size: 13px;
  color: #373334;
}
.Feed_askAbout__2aGRF > p {
  margin-bottom: 8px;
  font-size: 13px;
  color: #373334;
}
.Feed_askAboutHeadingContainer__MFnkU {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.Feed_askAboutHeadingContainer__MFnkU h6 {
  margin-bottom: 2px;
  font-size: 13px;
  color: #373334;
}
.Feed_askAboutHeadingContainer__MFnkU button {
  padding: 2px;
  border-width: 0px;
  border-radius: 50%;
  background-color: #f3f2f0;
  margin-top: -8px;
}
.Feed_AskAboutCloseIcon__3KV3S {
  height: 18px;
  width: 18px;
}
.Feed_aboutAskInfoicon__b2Jdt {
  /* bottom: 15%; */
  position: fixed;
}
.Feed_updateinfoicon__BaCM- {
  /* bottom: 24%; */
  position: fixed;
}

.Feed_aboutAskInfo__Su-qM:hover .Feed_askAbout__2aGRF {
  display: block;
  z-index: 2;
  /* position: absolute; */
  position: fixed;
  /* bottom: 64px; */
  box-shadow: 1px 1px 2px;
  border-radius: 25px;
  background: #fff;
  font-size: 11px;
  /* left: -13%; */
  right: 0%;
  bottom: 28%;
  max-width: 86%;
  padding: 18px 15px 7px 18px;
  /* background: #36B549; */
  /* opacity: 3; */
}

@media screen and (min-width: 1024px) {
  .Feed_aboutAskInfo__Su-qM:hover .Feed_askAbout__2aGRF {
    right: -20%;
  }
}
@media screen and (min-width: 1440px) {
  .Feed_aboutAskInfo__Su-qM:hover .Feed_askAbout__2aGRF {
    right: -60%;
  }
}

.Feed_modalfooter__6EnFZ > img:hover .Feed_askAbout__2aGRF {
  display: block;
  background: #9c1de7;
}

.Feed_hashValidationMessage__DY7sY {
  font-size: 13px;
  color: red;
}
.Feed_asksayselection__DnIAM {
  color: #000;
  opacity: 60%;
  font-size: 14px;
}

.Feed_updateHeaderContainer__VY\\+JB {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-bottom: -10px;
}
.Feed_updateHeaderContainer__VY\\+JB button {
  background-color: transparent;
  border-width: 0px;
  cursor: pointer;
  margin-top: -10px;
  margin-left: auto;
}
.Feed_updateHeaderImgContainer__a7NSD {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-left: auto;
}
.Feed_tagHeaderImgContainer__nSufw {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: relative;
}
.Feed_updateIcon__KtBw8 {
  height: 19px;
  margin-right: 6px;
  margin-top: -11px;
}
.Feed_tagIconImage__mZBYo {
  margin-left: auto;
  margin-bottom: 8px;
  transform: translateX(22px);
}
.Feed_tagCloseIconButton__mGFiB {
  margin-left: auto;
  border-width: 0px;
  background-color: transparent;
  outline: none !important;
  margin-bottom: 12px;
}
.Feed_updateText__uA\\+LI {
  font-weight: 400;
  font-size: 16px;
  color: #373334;
}
.Feed_closeIconButton__dz0Pg {
  outline: none !important;
}
.Feed_closeIcon__Tlx6Q {
  height: 18px;
  width: 18px;
  margin-left: -40px;
  outline: none !important;
}

.Feed_restrictedModal__GkLPS {
  border-radius: 15px; /* Border radius */
  background-color: #f9f9f9; /* Background color */
  text-align: center;
  height: 30vh;
  width: 40%;
  margin: auto;
  padding: 0px !important;
  padding-top: 0px !important;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  overflow: hidden !important;
}

.Feed_photoPreviewContainer__cx8OD {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80%;
  height: 88%;
  background-color: #ffffff;
  border-radius: 16px;
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.1); /* Adjust shadow as needed */
}
@media screen and (min-width: 1024px) {
  .Feed_photoPreviewContainer__cx8OD {
    width: 50%;
  }
}
.Feed_photoContainer__qL5bf {
  background-color: #36b549;
  /* margin: 2px 10px;s */
  margin-right: auto !important;
}
.Feed_slider__RReDe {
  background-color: pink !important;
  border: none !important;
}

.Feed_ContactHeadingContainer__vwMz\\+ {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.Feed_ContactHeading__jH2xB {
  margin-right: auto;
  color: #373334;
  font-size: 20px;
  font-weight: 700;
}
.Feed_contactCloseBtn__3NBU6 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 18px;
  width: 18px;
  padding: 13px;
  border-width: 0px;
  border-radius: 30px;
  background-color: #f3f2f0;
  outline: none !important;
}
.Feed_contactBoxName__FhMwE {
  margin-left: 20px;
  font-weight: 500;
  color: #373334;
}
.Feed_inputContainer__LX-bd {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
}

.Feed_attachmentContainer__nEZ6k {
  display: flex;
  align-items: center;
  gap: 5px; /* space between icon and file list */
  
}

.Feed_iconLabel__vAUAb {
  cursor: pointer;
  display: flex;
  align-items: center;
}
.Feed_attachIcon__Noiup {
  height: 17px;
  margin-left: 10px;
  margin-top: 5px;
}

.Feed_fileList__YknHh {
  display: flex;
  align-items: center;
  gap: 8px; /* spacing between files if multiple later */
  flex-wrap: wrap;
}

.Feed_fileItem__hYrMn {
  display: flex;
  align-items: center;
  gap: 6px;
  border-radius: 6px;
  padding: 4px 8px;
  font-size: 14px;
}

.Feed_fileName__kmKyl {
  color: #707070;
  font-weight: 500;
  max-width: 100px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.Feed_removeBtn__SVjdF {
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  cursor: pointer;
  outline: none !important;
  border-radius: 50%;
  background-color: #f4f4f4;
  padding: 4px;
}
.Feed_deleteIcon__sFtiA {
  height: 16px;
  width: 16px;
}
.Feed_popoverBtn__\\+IQzs {
  background: none;
  border: none;
  color: #1976d2;
  padding: 6px 10px;
  text-align: left;
  cursor: pointer;
  font-size: 14px;
  outline: none !important;
}

.Feed_popoverBtn__\\+IQzs:hover {
  background: #f1f1f1;
}

.Feed_moderatorFlex__Mev\\+F {
  display: flex;
  align-items: center;
  cursor: pointer;
  min-width: 0;
  flex: 1 1;
  overflow: hidden;
}

.Feed_moderatorFullName__N0LKi {
  font-size: 18px;
  font-weight: 500;
  color: #373334;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}

.Feed_prospectimagesdivFixed__EsvzP {
  display: flex;
  justify-content: flex-end;
  flex-shrink: 0;
}
`, "",{"version":3,"sources":["webpack://./src/Assets/css/home/Feed.module.css"],"names":[],"mappings":"AAAA;;GAEG;;AAEH;EACE,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,iCAAiC;EACjC,mBAAmB;EACnB,gBAAgB,EAAE,qDAAqD;AACzE;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;;AAEpB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,qEAAqE;EACrE,uDAAuD;EACvD,eAAe;AACjB;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,aAAa;EACb,gCAAgC;EAChC,WAAW;EACX,mBAAmB;EACnB,8BAA8B;EAC9B,yCAAyC;EACzC,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,UAAU;EACV,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;;EAExB,oCAAoC;EACpC,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;;EAExB,oCAAoC;EACpC,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;EACxB,oCAAoC;EACpC,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,wBAAwB;EACxB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,0EAA0E;AAC5E;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAO;EACP,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,YAAY;EACZ,UAAU;EACV,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,uDAAuD;AACzD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,+BAA+B;AACjC;AACA;EACE,oBAAoB,EAAE,6BAA6B;EACnD,mBAAmB,EAAE,sCAAsC;EAC3D,mBAAmB,EAAE,sBAAsB;EAC3C,yBAAyB;EACzB,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;EAC1B,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,cAAc,EAAE,+BAA+B;EAC/C,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;EAChC,YAAY;EACZ,gCAAgC;EAChC,UAAU;EACV,SAAS;EACT,oBAAoB;EACpB,WAAW;EACX,WAAW;EACX,6BAA6B;AAC/B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,aAAa;EACb,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,WAAW;AACb;;AAEA;;;;GAIG;;AAEH;EACE,aAAa;EACb,8BAA8B;EAC9B,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,cAAc,EAAE,uCAAuC;AACzD;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB,EAAE,6CAA6C;EAChE,QAAQ,EAAE,iDAAiD;EAC3D,SAAO,EAAE,yCAAyC;EAClD,YAAY;AACd;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,WAAW;IACX,mBAAmB;EACrB;AACF;;AAEA;EACE,4BAA4B;EAC5B,2CAA2C;EAC3C,UAAU;EACV,wBAAwB;EACxB,kCAAkC;AACpC;AACA;EACE,4BAA4B;EAC5B,2CAA2C;EAC3C,UAAU;EACV,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;AACzB;AACA;;;GAGG;;AAEH;EACE;IACE,WAAW;EACb;AACF;AACA;;;;GAIG;AACH;EACE;IACE,aAAa;;IAEb,0BAA0B;EAC5B;AACF;AACA;EACE;IACE,aAAa;;IAEb,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,WAAW;IACX,mBAAmB;EACrB;EACA;;KAEG;EACH;;KAEG;AACL;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;EACf,+BAA+B;EAC/B,uBAAuB;EACvB,8BAA8B;AAChC;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;;EAEZ,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;;EAEhB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,wBAAwB;EACxB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,+BAA+B;AACjC;AACA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,8BAA8B;EAC9B,yBAAyB;EACzB,+BAA+B;AACjC;AACA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,+BAA+B;AACjC;AACA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,8BAA8B;EAC9B,yBAAyB;EACzB,+BAA+B;AACjC;AACA;;EAEE,sBAAsB;EACtB,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,wBAAwB;EACxB,gCAAgC;EAChC,uBAAuB;EACvB,yBAAyB;AAC3B;AACA;EACE,wBAAwB;EACxB,gCAAgC;EAChC,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;AACtB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;EACf,8BAA8B;EAC9B,uBAAuB;EACvB,uBAAuB;EACvB,8BAA8B;EAC9B,oCAAoC;EACpC,+BAA+B;AACjC;AACA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;EACf,8BAA8B;EAC9B,uBAAuB;EACvB,uBAAuB;EACvB,8BAA8B;EAC9B,sCAAsC;EACtC,+BAA+B;AACjC;AACA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,uBAAuB;EACvB,eAAe;EACf,uBAAuB;EACvB,8BAA8B;EAC9B,oCAAoC;EACpC,+BAA+B;AACjC;AACA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,uBAAuB;EACvB,eAAe;EACf,uBAAuB;EACvB,8BAA8B;EAC9B,sCAAsC;EACtC,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;EACxB,UAAU;AACZ;AACA;EACE,8BAA8B;EAC9B,WAAW;EACX,oCAAoC;EACpC,cAAc;EACd,yBAAyB;EACzB,YAAY;EACZ,YAAY;AACd;AACA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,SAAS;;EAET;IACE,SAAS;EACX;AACF;;AAEA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,wBAAwB;EACxB,eAAe;EACf,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,WAAW;EACX,cAAc;EACd,2BAA2B;EAC3B,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,UAAU;AACZ;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,2BAA2B;AAC7B;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,6BAA6B;EAC7B,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB,EAAE,kBAAkB;EACvC,yBAAyB,EAAE,qBAAqB;EAChD,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,2CAA2C,EAAE,4BAA4B;AAC3E;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,6BAA6B;AAC/B;AACA;EACE,iCAAiC;EACjC,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,wBAAwB;AAC1B;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ,EAAE,qCAAqC;;AAEjD;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ,EAAE,4CAA4C;EACtD,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,wBAAwB;EACxB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,cAAc;AAChB","sourcesContent":["/* .modal{\r\n    z-index:999\r\n} */\r\n\r\n.modalHide {\r\n  display: none !important;\r\n}\r\n.feed {\r\n  width: 100%;\r\n  position: relative;\r\n  margin-top: 8px;\r\n  height: 153px;\r\n  border-radius: 26px;\r\n  box-shadow: 0px 3px 6px #00000029;\r\n  margin-bottom: 17px;\r\n  overflow: hidden; /* Ensures the image doesn't overflow the container */\r\n}\r\n.feedOnLoading {\r\n  width: 100%;\r\n  margin-top: 18px;\r\n  height: 153px;\r\n  margin-bottom: 17px;\r\n  text-align: center;\r\n\r\n}\r\n.backgroundImage {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background-size: cover;\r\n  /* object-fit: cover; Ensures the image covers the entire container */\r\n  /* z-index: -1; Places the image behind other content */\r\n  cursor: pointer;\r\n}\r\n.container {\r\n  bottom: 0;\r\n  position: absolute;\r\n  display: flex;\r\n  border-radius: 0px 0px 25px 25px;\r\n  width: 100%;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  background-color: rgb(243 242 240 / 100%);\r\n  padding: 5px 12px;\r\n}\r\n\r\n.navbuttons {\r\n  outline: none !important;\r\n  border: none !important;\r\n  background: #f3f2f0;\r\n  display: inline;\r\n  max-height: 43px;\r\n}\r\n\r\n.moderator {\r\n  display: flex;\r\n  align-items: center;\r\n  cursor: pointer;\r\n  width: 100%;\r\n}\r\n\r\n.coomFullName {\r\n  font-size: 18px;\r\n  font-weight: 500;\r\n  color: #373334;\r\n  margin: 0;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.crown {\r\n  position: absolute;\r\n  top: 20px;\r\n  left: 20px;\r\n  z-index: 1;\r\n}\r\n\r\n.post {\r\n  display: flex;\r\n  flex-flow: row nowrap;\r\n  align-items: center;\r\n  width: 48%;\r\n  border-radius: 20px;\r\n  border: solid 1px gray;\r\n}\r\n\r\n.postinput {\r\n  outline: none;\r\n  padding: 10px 10px 10px 20px;\r\n  border: none;\r\n  width: 100%;\r\n  border-radius: 25px;\r\n  position: relative;\r\n  font-size: 13px;\r\n  color: #707070;\r\n}\r\n\r\ninput::placeholder {\r\n  text-transform: none !important;\r\n}\r\n\r\n.post svg {\r\n  position: absolute;\r\n  left: 20px;\r\n}\r\n\r\n.updates {\r\n  width: 48px !important;\r\n}\r\n.prospectimages {\r\n  margin-right: 13px;\r\n}\r\n\r\n.postbutton {\r\n  outline: none !important;\r\n  border: none;\r\n  border-radius: 25px;\r\n  vertical-align: middle;\r\n  background-color: #707070;\r\n  padding: 6px 16px;\r\n}\r\n\r\n.postDialog {\r\n  outline: none !important;\r\n\r\n  background-color: #36b549 !important;\r\n  color: gray !important;\r\n  border-radius: 24px !important;\r\n}\r\n\r\n.UpdateDialog {\r\n  outline: none !important;\r\n\r\n  background-color: #ff7e7e !important;\r\n  color: white !important;\r\n  border-radius: 18px !important;\r\n}\r\n\r\n.TagDialog {\r\n  outline: none !important;\r\n  background-color: #ef8a2a !important;\r\n  color: white !important;\r\n  border-radius: 18px !important;\r\n}\r\n\r\n.close {\r\n  border: none;\r\n  outline: none !important;\r\n  background-color: white;\r\n  float: right;\r\n}\r\n\r\n.togglebuttoncover {\r\n  display: table-cell;\r\n  position: relative;\r\n  width: 200px;\r\n  height: 140px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.navHome {\r\n  border-radius: 50px;\r\n  width: 15vw;\r\n  height: 60px;\r\n  line-height: 60px;\r\n  background: #fff;\r\n  border: none;\r\n  outline: none;\r\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);\r\n}\r\n\r\n.navHome > nav {\r\n  display: flex;\r\n  position: relative;\r\n}\r\n\r\n.navHome > nav > label {\r\n  text-align: center;\r\n  z-index: 1;\r\n  flex: 1;\r\n  width: 100%;\r\n  position: relative;\r\n  cursor: pointer;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.navHome > nav > label > a {\r\n  z-index: -1;\r\n  position: relative;\r\n  font-size: 18px;\r\n  font-weight: 500;\r\n  text-decoration: none;\r\n  color: #000;\r\n  transition: color 0.6s ease;\r\n}\r\n\r\n.navHome > nav > .tab {\r\n  position: absolute;\r\n  left: 0;\r\n  height: 100%;\r\n  width: 50%;\r\n  bottom: 0;\r\n  border-radius: 50px;\r\n  background-color: #9c1de7;\r\n  transition: 0.6s cubic-bezier(0.68, -0.55, 0.265, 1.55);\r\n}\r\n\r\n.navHome > nav > input {\r\n  display: none;\r\n}\r\n\r\n.navHome > nav > .home:checked ~ .navhome > .asksaynav > label > .home > a {\r\n  color: #fff;\r\n}\r\n\r\n.navHome > nav > #phone:checked ~ .tab {\r\n  left: 50%;\r\n}\r\n\r\n.prospectimagesdiv {\r\n  display: flex;\r\n  /* width: 50%; */\r\n  justify-content: flex-end;\r\n  /* background-color: #50b7f5; */\r\n}\r\n.invitebutton {\r\n  display: inline-flex; /* keeps icon + text inline */\r\n  align-items: center; /* vertically centers icon with text */\r\n  white-space: nowrap; /* prevents wrapping */\r\n  border: 1px solid #DEE0E1;\r\n  outline: none !important;\r\n  border-radius: 19px;\r\n  background: #fff;\r\n  padding: 3px 10px 3px 13px;\r\n  color: #373334 !important;\r\n  font-size: 14px;\r\n}\r\n.invitebutton svg {\r\n  margin-right: 5px;\r\n  flex-shrink: 0; /* ensures icon never shrinks */\r\n  position: relative;\r\n  /* top: 2px; */\r\n}\r\n\r\n.filterbuttons {\r\n  padding-top: 7px;\r\n  position: absolute;\r\n  box-shadow: 2px 3px 6px darkgrey;\r\n  width: 295px;\r\n  border-radius: 25px 25px 0px 4px;\r\n  right: 0px;\r\n  top: 65px;\r\n  display: inline-flex;\r\n  z-index: -2;\r\n  bottom: 3px;\r\n  justify-content: space-evenly;\r\n}\r\n.filterbuttons > span {\r\n  padding: 0px 0px 0px 8px;\r\n}\r\n.filterinput {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  /* padding: 5px 0px 5px 20px; */\r\n  padding: 5px 0px;\r\n  cursor: pointer;\r\n}\r\n\r\n.modalbgcolor {\r\n  background-color: #f3f2f0;\r\n  border-radius: 25px;\r\n  margin-top: 48px;\r\n}\r\n\r\n.modalbody {\r\n  background-color: white;\r\n  margin: 0px 30px;\r\n  border-radius: 25px;\r\n}\r\n.communitydropdown {\r\n  border-color: black;\r\n  background-color: #fff;\r\n  color: black;\r\n  border-radius: 15px;\r\n}\r\n.communitydropdown:hover {\r\n  border-color: black;\r\n  background-color: #fff;\r\n  color: black;\r\n}\r\n.profilenameandimage {\r\n  display: flex;\r\n  margin-bottom: 10px;\r\n}\r\n.profilename {\r\n  margin: 0px 0px 0px 8px;\r\n  font-size: 14px;\r\n  font-weight: bold;\r\n  color: #333;\r\n}\r\n.profilename > p {\r\n  margin: 0 0 0 2px;\r\n  font-size: 14px;\r\n  /* margin-bottom: 0; */\r\n}\r\n.askSayTextareaContainer {\r\n  display: flex;\r\n  flex-direction: column;\r\n  position: relative;\r\n  margin-bottom: 20px;\r\n}\r\n.asksaytextarea {\r\n  width: 100%;\r\n  height: 100px;\r\n  resize: none;\r\n  outline: none;\r\n  border-width: 0px;\r\n  border-bottom-width: 1px;\r\n  border-color: gray;\r\n  font-size: 14px;\r\n}\r\n.redBubble {\r\n  margin-left: auto;\r\n  margin-top: -23px;\r\n  height: 8px;\r\n}\r\n.textAreaHorizontalLine {\r\n  color: red;\r\n}\r\n.locationtagandcharcount {\r\n  padding-top: 4px;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-content: baseline;\r\n  flex-wrap: wrap;\r\n}\r\n.locationtagTimeFileandcharcount {\r\n  padding-top: 4px;\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  gap: 10px;\r\n  width: 100%;\r\n}\r\n\r\n/* .locationtagicon {\r\n  margin-top: 10px !important;\r\n  position: absolute !important;\r\n  bottom: 14% !important;\r\n} */\r\n\r\n.locationtagicon {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-content: flex-start;\r\n  align-items: start;\r\n  flex-wrap: wrap;\r\n}\r\n.locationtagTimeFileandcharcount > div:last-child {\r\n  flex-shrink: 0; /* prevents char count from shrinking */\r\n}\r\n.locationtagTimeFileIcon {\r\n  display: flex;\r\n  align-items: center;\r\n  flex-wrap: nowrap; /* allows items to wrap if not enough space */\r\n  gap: 8px; /* space between location, calendar, attachment */\r\n  flex: 1; /* makes it expand and shrink as needed */\r\n  min-width: 0;\r\n}\r\n\r\n.profileavatar {\r\n  margin-top: 4px;\r\n  height: 45px !important;\r\n  width: 45px !important;\r\n}\r\n\r\n@media all and (min-width: 1440px) {\r\n  .modalbgcolor {\r\n    width: 600px;\r\n  }\r\n}\r\n\r\n@media all and (min-width: 768px) {\r\n  .asksaybuttons {\r\n    position: relative;\r\n    left: 152px;\r\n    margin-bottom: 14px;\r\n  }\r\n}\r\n\r\n.askbutton {\r\n  border: 1px solid !important;\r\n  border-radius: 50px 0px 0px 50px !important;\r\n  width: 21%;\r\n  outline: none !important;\r\n  background-color: white !important;\r\n}\r\n.saybutton {\r\n  border: 1px solid !important;\r\n  border-radius: 0px 50px 50px 0px !important;\r\n  width: 21%;\r\n  outline: none !important;\r\n  background-color: white !important;\r\n}\r\n\r\n.modalfooter {\r\n  justify-content: center;\r\n}\r\n/* .modalfooter>img{\r\n    position: absolute;\r\n    right: 30px;\r\n} */\r\n\r\n@media all and (max-width: 991px) {\r\n  .post {\r\n    width: 100%;\r\n  }\r\n}\r\n/* @media all and (max-width: 967px) {\r\n  .container {\r\n    padding-top: 50px;\r\n  }\r\n} */\r\n@media all and (max-width: 320px) {\r\n  .backgroundimage > img {\r\n    width: 101.5%;\r\n\r\n    margin: -94px 0px 0px -1px;\r\n  }\r\n}\r\n@media all and (max-width: 425px) {\r\n  .backgroundimage > img {\r\n    width: 102.5%;\r\n\r\n    margin: -94px 0px 0px -5px;\r\n  }\r\n}\r\n\r\n@media all and (max-width: 767px) {\r\n  .asksaybuttons {\r\n    position: relative;\r\n    left: 100px;\r\n    margin-bottom: 14px;\r\n  }\r\n  /* .post svg {\r\n    left: 25px;\r\n  } */\r\n  /* .filterinput {\r\n    padding: 0 10px;\r\n  } */\r\n}\r\n\r\n.postupdatedropdown {\r\n  border-radius: 8px;\r\n  padding: 5px 11px;\r\n  border: 1px solid #999999;\r\n  color: rgba(0, 0, 0, 0.6);\r\n  font-size: 12px;\r\n}\r\n\r\n.postdropdown {\r\n  /* padding: 5px 11px; */\r\n  color: rgba(0, 0, 0, 0.6);\r\n  font-size: 12px;\r\n}\r\n\r\n.arrowStyle {\r\n  height: 10px;\r\n  width: 10px;\r\n}\r\n\r\n.PostSubmit {\r\n  border-radius: 25px;\r\n  min-width: 106px !important;\r\n  cursor: pointer;\r\n  /* background-color: #d8d8d8; */\r\n  box-shadow: 1px 3px 6px;\r\n  border-radius: 25px !important;\r\n}\r\n.postSelectionWarning {\r\n  z-index: 20;\r\n  position: absolute;\r\n  bottom: 18px;\r\n\r\n  box-shadow: 1px 2px 4px;\r\n  border-radius: 55px;\r\n  background: #fff;\r\n\r\n  font-size: 12px;\r\n  /* left: 41px; */\r\n  width: 100%;\r\n  /* width: max-content; */\r\n  text-align: center;\r\n  padding: 13px 12px 0px 12px;\r\n}\r\n\r\n.askpost {\r\n  background-color: #2168b2 !important;\r\n  color: #ffffff !important;\r\n  text-transform: none !important;\r\n}\r\n.askButtonDisable {\r\n  background-color: #a2c3e4 !important;\r\n  opacity: 0.4 !important;\r\n  cursor: not-allowed !important;\r\n  color: #ffffff !important;\r\n  text-transform: none !important;\r\n}\r\n.saypost {\r\n  background-color: #36b549 !important;\r\n  color: #ffffff !important;\r\n  text-transform: none !important;\r\n}\r\n.sayButtonDisable {\r\n  background-color: #a8d9b0 !important;\r\n  opacity: 0.4 !important;\r\n  cursor: not-allowed !important;\r\n  color: #ffffff !important;\r\n  text-transform: none !important;\r\n}\r\n.saypost,\r\n.askpost {\r\n  width: 6rem !important;\r\n  /* color: #fff !important; */\r\n  padding-top: 9px;\r\n}\r\n.initialcount {\r\n  position: relative;\r\n  bottom: 5px;\r\n}\r\n\r\n.additionalcountadd {\r\n  margin-left: 4px;\r\n  color: #707070;\r\n}\r\n.publicSwitch {\r\n  outline: none !important;\r\n  border-radius: 50px 0px 0px 50px;\r\n  background-color: white;\r\n  border: 0.5px solid black;\r\n}\r\n.privateSwitch {\r\n  outline: none !important;\r\n  border-radius: 0px 50px 50px 0px;\r\n  background-color: white;\r\n  border: 0.5px solid black;\r\n}\r\n\r\n.tagDiv > img {\r\n  margin: 0 0 10px 0px;\r\n}\r\n.tagDiv > div {\r\n  list-style: none;\r\n}\r\n.tagDiv > div > button {\r\n  padding: 3px 15px 3px 15px;\r\n  font-size: 14px;\r\n}\r\n.onPublicSwitchSelect {\r\n  color: #50b7f5;\r\n  border: 1px solid #50b7f5;\r\n  background-color: #eff5fb;\r\n}\r\n.onPrivateSwitchSelect {\r\n  color: #50b7f5;\r\n  border: 1px solid #50b7f5;\r\n  background-color: #eff5fb;\r\n}\r\n.updateSubmit {\r\n  border-radius: 25px;\r\n  min-width: 106px !important;\r\n  cursor: pointer;\r\n  /* background-color:#D8D8D8; */\r\n  color: white !important;\r\n  box-shadow: 1px 3px 6px;\r\n  border-radius: 25px !important;\r\n  background-color: #e82727 !important;\r\n  text-transform: none !important;\r\n}\r\n.updateButtonDisable {\r\n  border-radius: 25px;\r\n  min-width: 106px !important;\r\n  cursor: pointer;\r\n  /* background-color:#D8D8D8; */\r\n  color: white !important;\r\n  box-shadow: 1px 3px 6px;\r\n  border-radius: 25px !important;\r\n  background-color: #e827274f !important;\r\n  text-transform: none !important;\r\n}\r\n.tagSubmit {\r\n  border-radius: 25px;\r\n  min-width: 106px !important;\r\n  color: white !important;\r\n  cursor: pointer;\r\n  box-shadow: 1px 3px 6px;\r\n  border-radius: 25px !important;\r\n  background-color: #efba29 !important;\r\n  text-transform: none !important;\r\n}\r\n.tagButtonDisable {\r\n  border-radius: 25px;\r\n  min-width: 106px !important;\r\n  color: white !important;\r\n  cursor: pointer;\r\n  box-shadow: 1px 3px 6px;\r\n  border-radius: 25px !important;\r\n  background-color: #efba298b !important;\r\n  text-transform: none !important;\r\n}\r\n\r\n.errorMessage {\r\n  color: red;\r\n  font-size: 12px;\r\n}\r\n\r\n/*Contact component */\r\n.address {\r\n  display: flex;\r\n  margin-left: 5%;\r\n}\r\n.address p {\r\n  margin-right: 5px;\r\n  margin-top: -2px;\r\n}\r\n.contactModalbgcolor {\r\n  background-color: #ffffff;\r\n  border-radius: 25px;\r\n}\r\n.contactTextarea {\r\n  border: 1px solid #707070;\r\n  margin-left: 4px;\r\n  border-radius: 20px !important;\r\n  resize: none;\r\n  padding-left: 15px;\r\n  padding-top: 5px;\r\n  padding-bottom: 5px;\r\n  outline: none !important;\r\n  width: 98%;\r\n}\r\n.contactSend {\r\n  border-radius: 25px !important;\r\n  width: 88px;\r\n  background-color: #4795de !important;\r\n  margin: 0 auto;\r\n  color: #ffffff !important;\r\n  border: none;\r\n  height: 33px;\r\n}\r\n.sendtoContact {\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\n.addressContact {\r\n  color: #4795de;\r\n}\r\n\r\n.contactSendButton {\r\n  cursor: none;\r\n  opacity: 0.6;\r\n}\r\n.overCount {\r\n  color: red;\r\n}\r\n\r\n.aboutAskInfo {\r\n  position: relative;\r\n  cursor: pointer;\r\n  left: 35%;\r\n\r\n  @media screen and (max-width: 576px) {\r\n    left: 28%;\r\n  }\r\n}\r\n\r\n.askAbout {\r\n  display: none;\r\n}\r\n.askAbout > h6 {\r\n  margin-bottom: 2px;\r\n  font-size: 13px;\r\n  color: #373334;\r\n}\r\n.askAbout > p {\r\n  margin-bottom: 8px;\r\n  font-size: 13px;\r\n  color: #373334;\r\n}\r\n.askAboutHeadingContainer {\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n.askAboutHeadingContainer h6 {\r\n  margin-bottom: 2px;\r\n  font-size: 13px;\r\n  color: #373334;\r\n}\r\n.askAboutHeadingContainer button {\r\n  padding: 2px;\r\n  border-width: 0px;\r\n  border-radius: 50%;\r\n  background-color: #f3f2f0;\r\n  margin-top: -8px;\r\n}\r\n.AskAboutCloseIcon {\r\n  height: 18px;\r\n  width: 18px;\r\n}\r\n.aboutAskInfoicon {\r\n  /* bottom: 15%; */\r\n  position: fixed;\r\n}\r\n.updateinfoicon {\r\n  /* bottom: 24%; */\r\n  position: fixed;\r\n}\r\n\r\n.aboutAskInfo:hover .askAbout {\r\n  display: block;\r\n  z-index: 2;\r\n  /* position: absolute; */\r\n  position: fixed;\r\n  /* bottom: 64px; */\r\n  box-shadow: 1px 1px 2px;\r\n  border-radius: 25px;\r\n  background: #fff;\r\n  font-size: 11px;\r\n  /* left: -13%; */\r\n  right: 0%;\r\n  bottom: 28%;\r\n  max-width: 86%;\r\n  padding: 18px 15px 7px 18px;\r\n  /* background: #36B549; */\r\n  /* opacity: 3; */\r\n}\r\n\r\n@media screen and (min-width: 1024px) {\r\n  .aboutAskInfo:hover .askAbout {\r\n    right: -20%;\r\n  }\r\n}\r\n@media screen and (min-width: 1440px) {\r\n  .aboutAskInfo:hover .askAbout {\r\n    right: -60%;\r\n  }\r\n}\r\n\r\n.modalfooter > img:hover .askAbout {\r\n  display: block;\r\n  background: #9c1de7;\r\n}\r\n\r\n.hashValidationMessage {\r\n  font-size: 13px;\r\n  color: red;\r\n}\r\n.asksayselection {\r\n  color: #000;\r\n  opacity: 60%;\r\n  font-size: 14px;\r\n}\r\n\r\n.updateHeaderContainer {\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: center;\r\n  align-items: center;\r\n  margin-bottom: -10px;\r\n}\r\n.updateHeaderContainer button {\r\n  background-color: transparent;\r\n  border-width: 0px;\r\n  cursor: pointer;\r\n  margin-top: -10px;\r\n  margin-left: auto;\r\n}\r\n.updateHeaderImgContainer {\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: center;\r\n  align-items: center;\r\n  margin-left: auto;\r\n}\r\n.tagHeaderImgContainer {\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: center;\r\n  align-items: center;\r\n  position: relative;\r\n}\r\n.updateIcon {\r\n  height: 19px;\r\n  margin-right: 6px;\r\n  margin-top: -11px;\r\n}\r\n.tagIconImage {\r\n  margin-left: auto;\r\n  margin-bottom: 8px;\r\n  transform: translateX(22px);\r\n}\r\n.tagCloseIconButton {\r\n  margin-left: auto;\r\n  border-width: 0px;\r\n  background-color: transparent;\r\n  outline: none !important;\r\n  margin-bottom: 12px;\r\n}\r\n.updateText {\r\n  font-weight: 400;\r\n  font-size: 16px;\r\n  color: #373334;\r\n}\r\n.closeIconButton {\r\n  outline: none !important;\r\n}\r\n.closeIcon {\r\n  height: 18px;\r\n  width: 18px;\r\n  margin-left: -40px;\r\n  outline: none !important;\r\n}\r\n\r\n.restrictedModal {\r\n  border-radius: 15px; /* Border radius */\r\n  background-color: #f9f9f9; /* Background color */\r\n  text-align: center;\r\n  height: 30vh;\r\n  width: 40%;\r\n  margin: auto;\r\n  padding: 0px !important;\r\n  padding-top: 0px !important;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: flex-start;\r\n  align-items: flex-start;\r\n  overflow: hidden !important;\r\n}\r\n\r\n.photoPreviewContainer {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  width: 80%;\r\n  height: 88%;\r\n  background-color: #ffffff;\r\n  border-radius: 16px;\r\n  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.1); /* Adjust shadow as needed */\r\n}\r\n@media screen and (min-width: 1024px) {\r\n  .photoPreviewContainer {\r\n    width: 50%;\r\n  }\r\n}\r\n.photoContainer {\r\n  background-color: #36b549;\r\n  /* margin: 2px 10px;s */\r\n  margin-right: auto !important;\r\n}\r\n.slider {\r\n  background-color: pink !important;\r\n  border: none !important;\r\n}\r\n\r\n.ContactHeadingContainer {\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n.ContactHeading {\r\n  margin-right: auto;\r\n  color: #373334;\r\n  font-size: 20px;\r\n  font-weight: 700;\r\n}\r\n.contactCloseBtn {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  height: 18px;\r\n  width: 18px;\r\n  padding: 13px;\r\n  border-width: 0px;\r\n  border-radius: 30px;\r\n  background-color: #f3f2f0;\r\n  outline: none !important;\r\n}\r\n.contactBoxName {\r\n  margin-left: 20px;\r\n  font-weight: 500;\r\n  color: #373334;\r\n}\r\n.inputContainer {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: flex-start;\r\n}\r\n\r\n.attachmentContainer {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 5px; /* space between icon and file list */\r\n  \r\n}\r\n\r\n.iconLabel {\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n.attachIcon {\r\n  height: 17px;\r\n  margin-left: 10px;\r\n  margin-top: 5px;\r\n}\r\n\r\n.fileList {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px; /* spacing between files if multiple later */\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.fileItem {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  border-radius: 6px;\r\n  padding: 4px 8px;\r\n  font-size: 14px;\r\n}\r\n\r\n.fileName {\r\n  color: #707070;\r\n  font-weight: 500;\r\n  max-width: 100px;\r\n  text-overflow: ellipsis;\r\n  overflow: hidden;\r\n  white-space: nowrap;\r\n}\r\n\r\n.removeBtn {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border: none;\r\n  cursor: pointer;\r\n  outline: none !important;\r\n  border-radius: 50%;\r\n  background-color: #f4f4f4;\r\n  padding: 4px;\r\n}\r\n.deleteIcon {\r\n  height: 16px;\r\n  width: 16px;\r\n}\r\n.popoverBtn {\r\n  background: none;\r\n  border: none;\r\n  color: #1976d2;\r\n  padding: 6px 10px;\r\n  text-align: left;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n  outline: none !important;\r\n}\r\n\r\n.popoverBtn:hover {\r\n  background: #f1f1f1;\r\n}\r\n\r\n.moderatorFlex {\r\n  display: flex;\r\n  align-items: center;\r\n  cursor: pointer;\r\n  min-width: 0;\r\n  flex: 1;\r\n  overflow: hidden;\r\n}\r\n\r\n.moderatorFullName {\r\n  font-size: 18px;\r\n  font-weight: 500;\r\n  color: #373334;\r\n  margin: 0;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  min-width: 0;\r\n}\r\n\r\n.prospectimagesdivFixed {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  flex-shrink: 0;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalHide": `Feed_modalHide__g8BFy`,
	"feed": `Feed_feed__NFWkr`,
	"feedOnLoading": `Feed_feedOnLoading__QPvVL`,
	"backgroundImage": `Feed_backgroundImage__SPblc`,
	"container": `Feed_container__gMeS2`,
	"navbuttons": `Feed_navbuttons__z7ALu`,
	"moderator": `Feed_moderator__J03se`,
	"coomFullName": `Feed_coomFullName__HdSIo`,
	"crown": `Feed_crown__PWAEU`,
	"post": `Feed_post__tpjac`,
	"postinput": `Feed_postinput__HkX17`,
	"updates": `Feed_updates__xk+kX`,
	"prospectimages": `Feed_prospectimages__xNGKl`,
	"postbutton": `Feed_postbutton__PKKXc`,
	"postDialog": `Feed_postDialog__uXQfy`,
	"UpdateDialog": `Feed_UpdateDialog__0RkfR`,
	"TagDialog": `Feed_TagDialog__yQi9-`,
	"close": `Feed_close__L8aJp`,
	"togglebuttoncover": `Feed_togglebuttoncover__gcFk0`,
	"navHome": `Feed_navHome__0LOEG`,
	"tab": `Feed_tab__gu+xM`,
	"home": `Feed_home__tAhO3`,
	"navhome": `Feed_navhome__dWHWP`,
	"asksaynav": `Feed_asksaynav__Xe7Ay`,
	"phone": `Feed_phone__JW9kp`,
	"prospectimagesdiv": `Feed_prospectimagesdiv__IYiDk`,
	"invitebutton": `Feed_invitebutton__Hrq5A`,
	"filterbuttons": `Feed_filterbuttons__LXvlo`,
	"filterinput": `Feed_filterinput__HYj-n`,
	"modalbgcolor": `Feed_modalbgcolor__6q-7o`,
	"modalbody": `Feed_modalbody__h-t0x`,
	"communitydropdown": `Feed_communitydropdown__BQBeH`,
	"profilenameandimage": `Feed_profilenameandimage__rA9aM`,
	"profilename": `Feed_profilename__z6+VV`,
	"askSayTextareaContainer": `Feed_askSayTextareaContainer__YbYjz`,
	"asksaytextarea": `Feed_asksaytextarea__28JhJ`,
	"redBubble": `Feed_redBubble__Zzie0`,
	"textAreaHorizontalLine": `Feed_textAreaHorizontalLine__MeAQB`,
	"locationtagandcharcount": `Feed_locationtagandcharcount__7OweD`,
	"locationtagTimeFileandcharcount": `Feed_locationtagTimeFileandcharcount__9tsId`,
	"locationtagicon": `Feed_locationtagicon__N6ybO`,
	"locationtagTimeFileIcon": `Feed_locationtagTimeFileIcon__pFWEL`,
	"profileavatar": `Feed_profileavatar__benSa`,
	"asksaybuttons": `Feed_asksaybuttons__Nmdh7`,
	"askbutton": `Feed_askbutton__CZNDH`,
	"saybutton": `Feed_saybutton__zd6n3`,
	"modalfooter": `Feed_modalfooter__6EnFZ`,
	"backgroundimage": `Feed_backgroundimage__g9y2N`,
	"postupdatedropdown": `Feed_postupdatedropdown__5DVeE`,
	"postdropdown": `Feed_postdropdown__h7KHi`,
	"arrowStyle": `Feed_arrowStyle__fmwcO`,
	"PostSubmit": `Feed_PostSubmit__28KO2`,
	"postSelectionWarning": `Feed_postSelectionWarning__4ojnC`,
	"askpost": `Feed_askpost__Ifips`,
	"askButtonDisable": `Feed_askButtonDisable__qcbi+`,
	"saypost": `Feed_saypost__S0fmr`,
	"sayButtonDisable": `Feed_sayButtonDisable__OEg62`,
	"initialcount": `Feed_initialcount__8pPEi`,
	"additionalcountadd": `Feed_additionalcountadd__UHrBE`,
	"publicSwitch": `Feed_publicSwitch__BP3Gr`,
	"privateSwitch": `Feed_privateSwitch__6Y1BX`,
	"tagDiv": `Feed_tagDiv__FToZK`,
	"onPublicSwitchSelect": `Feed_onPublicSwitchSelect__en6qk`,
	"onPrivateSwitchSelect": `Feed_onPrivateSwitchSelect__IbQDE`,
	"updateSubmit": `Feed_updateSubmit__uUvB4`,
	"updateButtonDisable": `Feed_updateButtonDisable__hL0gM`,
	"tagSubmit": `Feed_tagSubmit__HtSmO`,
	"tagButtonDisable": `Feed_tagButtonDisable__xKvz7`,
	"errorMessage": `Feed_errorMessage__cs3tq`,
	"address": `Feed_address__KK+zg`,
	"contactModalbgcolor": `Feed_contactModalbgcolor__IQOx1`,
	"contactTextarea": `Feed_contactTextarea__ynMnP`,
	"contactSend": `Feed_contactSend__GhKMv`,
	"sendtoContact": `Feed_sendtoContact__Se6vh`,
	"addressContact": `Feed_addressContact__ucZ2+`,
	"contactSendButton": `Feed_contactSendButton__PGGrH`,
	"overCount": `Feed_overCount__iJ5cG`,
	"aboutAskInfo": `Feed_aboutAskInfo__Su-qM`,
	"askAbout": `Feed_askAbout__2aGRF`,
	"askAboutHeadingContainer": `Feed_askAboutHeadingContainer__MFnkU`,
	"AskAboutCloseIcon": `Feed_AskAboutCloseIcon__3KV3S`,
	"aboutAskInfoicon": `Feed_aboutAskInfoicon__b2Jdt`,
	"updateinfoicon": `Feed_updateinfoicon__BaCM-`,
	"hashValidationMessage": `Feed_hashValidationMessage__DY7sY`,
	"asksayselection": `Feed_asksayselection__DnIAM`,
	"updateHeaderContainer": `Feed_updateHeaderContainer__VY+JB`,
	"updateHeaderImgContainer": `Feed_updateHeaderImgContainer__a7NSD`,
	"tagHeaderImgContainer": `Feed_tagHeaderImgContainer__nSufw`,
	"updateIcon": `Feed_updateIcon__KtBw8`,
	"tagIconImage": `Feed_tagIconImage__mZBYo`,
	"tagCloseIconButton": `Feed_tagCloseIconButton__mGFiB`,
	"updateText": `Feed_updateText__uA+LI`,
	"closeIconButton": `Feed_closeIconButton__dz0Pg`,
	"closeIcon": `Feed_closeIcon__Tlx6Q`,
	"restrictedModal": `Feed_restrictedModal__GkLPS`,
	"photoPreviewContainer": `Feed_photoPreviewContainer__cx8OD`,
	"photoContainer": `Feed_photoContainer__qL5bf`,
	"slider": `Feed_slider__RReDe`,
	"ContactHeadingContainer": `Feed_ContactHeadingContainer__vwMz+`,
	"ContactHeading": `Feed_ContactHeading__jH2xB`,
	"contactCloseBtn": `Feed_contactCloseBtn__3NBU6`,
	"contactBoxName": `Feed_contactBoxName__FhMwE`,
	"inputContainer": `Feed_inputContainer__LX-bd`,
	"attachmentContainer": `Feed_attachmentContainer__nEZ6k`,
	"iconLabel": `Feed_iconLabel__vAUAb`,
	"attachIcon": `Feed_attachIcon__Noiup`,
	"fileList": `Feed_fileList__YknHh`,
	"fileItem": `Feed_fileItem__hYrMn`,
	"fileName": `Feed_fileName__kmKyl`,
	"removeBtn": `Feed_removeBtn__SVjdF`,
	"deleteIcon": `Feed_deleteIcon__sFtiA`,
	"popoverBtn": `Feed_popoverBtn__+IQzs`,
	"moderatorFlex": `Feed_moderatorFlex__Mev+F`,
	"moderatorFullName": `Feed_moderatorFullName__N0LKi`,
	"prospectimagesdivFixed": `Feed_prospectimagesdivFixed__EsvzP`
};
export default ___CSS_LOADER_EXPORT___;
